import { ColumnConfig, TurnoverSchemeReportColumnKey } from '../../model';

// Header background colors per section (Figma design)
const DISTRIBUTOR_HEADER_BG = '#EAF8F2';
const RETAILER_HEADER_BG = '#FFF7E6';
const INVOICE_HEADER_BG = '#E6F0FF';
const MATERIAL_HEADER_BG = '#F4ECFF';

export const turnoverSchemeReportConfig: Record<
  TurnoverSchemeReportColumnKey,
  ColumnConfig
> = {
  sNo: {
    name: 'S.No',
    headerBackgroundColor: '#F5F5F5',
  },
  // Distributor Col
  distributorCode: {
    name: 'Distributor Code(SAP)',
    headerBackgroundColor: DISTRIBUTOR_HEADER_BG,
  },
  distributorName: {
    name: 'Distributor Name',
    headerBackgroundColor: DISTRIBUTOR_HEADER_BG,
  },
  distributorGst: {
    name: 'Distributor GST',
    headerBackgroundColor: DISTRIBUTOR_HEADER_BG,
  },
  distributorMobileNo: {
    name: 'Distributor Mobile No',
    headerBackgroundColor: DISTRIBUTOR_HEADER_BG,
  },
  distributorStatus: {
    name: 'Distributor Status',
    headerBackgroundColor: DISTRIBUTOR_HEADER_BG,
  },
  // Retailer Col
  retailerCode: {
    name: 'Retailer Code (SFA)',
    headerBackgroundColor: RETAILER_HEADER_BG,
  },
  retailerName: {
    name: 'Retailer Name',
    headerBackgroundColor: RETAILER_HEADER_BG,
  },
  retailerGst: {
    name: 'Retailer GST',
    headerBackgroundColor: RETAILER_HEADER_BG,
  },
  retailerMobileNo: {
    name: 'Retailer Mobile No',
    headerBackgroundColor: RETAILER_HEADER_BG,
  },
  retailerPinCode: {
    name: 'Retailer Pin Code',
    headerBackgroundColor: RETAILER_HEADER_BG,
  },
  retailerStatus: {
    name: 'Retailer Status',
    headerBackgroundColor: RETAILER_HEADER_BG,
  },
  // Invoice Col
  invoiceDate: {
    name: 'Invoice Date',
    headerBackgroundColor: INVOICE_HEADER_BG,
  },
  invoiceNumber: {
    name: 'Invoice Number',
    headerBackgroundColor: INVOICE_HEADER_BG,
  },
  ewayBillNo: {
    name: 'E-way Bill No',
    headerBackgroundColor: INVOICE_HEADER_BG,
  },
  invoiceStatus: {
    name: 'Invoice Status',
    headerBackgroundColor: INVOICE_HEADER_BG,
  },
  validationStatus: {
    name: 'Validation Status',
    headerBackgroundColor: INVOICE_HEADER_BG,
  },
  submittedBy: {
    name: 'Submitted By',
    headerBackgroundColor: INVOICE_HEADER_BG,
  },
  submittedDate: {
    name: 'Submitted Date',
    headerBackgroundColor: INVOICE_HEADER_BG,
  },
  approvedBy: {
    name: 'Approved By',
    headerBackgroundColor: INVOICE_HEADER_BG,
  },
  approveDate: {
    name: 'Approved Date',
    headerBackgroundColor: INVOICE_HEADER_BG,
  },
  rejectedBy: {
    name: 'Rejected By',
    headerBackgroundColor: INVOICE_HEADER_BG,
  },
  receivedDate: {
    name: 'Rejected Date',
    headerBackgroundColor: INVOICE_HEADER_BG,
  },
  rejectedReason: {
    name: 'Rejected Reason',
    headerBackgroundColor: INVOICE_HEADER_BG,
  },
  // Material Col
  materialNo: {
    name: 'Material No',
    headerBackgroundColor: MATERIAL_HEADER_BG,
    alignment: 'flex-end',
  },
  materialDescription: {
    name: 'Material Description',
    headerBackgroundColor: MATERIAL_HEADER_BG,
  },
  materialDescriptionSecondaryInvoice: {
    name: 'Material Description in Secondary Invoice',
    headerBackgroundColor: MATERIAL_HEADER_BG,
  },
  parsingStatus: {
    name: 'Line Level Status',
    headerBackgroundColor: MATERIAL_HEADER_BG,
  },
  categoryName: {
    name: 'Category Name',
    headerBackgroundColor: MATERIAL_HEADER_BG,
  },
  hsn: {
    name: 'HSN',
    headerBackgroundColor: MATERIAL_HEADER_BG,
  },
  qty: {
    name: 'QTY',
    alignment: 'flex-end',
    headerBackgroundColor: MATERIAL_HEADER_BG,
  },
  basePriceRate: {
    name: 'Base Price (Rate)',
    alignment: 'flex-end',
    headerBackgroundColor: MATERIAL_HEADER_BG,
  },
  unitPriceWithTax: {
    name: 'Unit Price (With Tax)',
    alignment: 'flex-end',
    headerBackgroundColor: MATERIAL_HEADER_BG,
  },
  discount1: {
    name: 'Discount 1',
    alignment: 'flex-end',
    headerBackgroundColor: MATERIAL_HEADER_BG,
  },
  discount2: {
    name: 'Discount 2',
    alignment: 'flex-end',
    headerBackgroundColor: MATERIAL_HEADER_BG,
  },
  totalAmountNetDiscount: {
    name: 'Total Amount (Net Discount)',
    alignment: 'flex-end',
    headerBackgroundColor: MATERIAL_HEADER_BG,
  },
  freight: {
    name: 'Freight',
    alignment: 'flex-end',
    headerBackgroundColor: MATERIAL_HEADER_BG,
  },
  totalAmountExcludingTax: {
    name: 'Total Amount (Excluding Tax)',
    alignment: 'flex-end',
    headerBackgroundColor: MATERIAL_HEADER_BG,
  },
  appliedScheme: {
    name: 'Applied Scheme',
    headerBackgroundColor: MATERIAL_HEADER_BG,
    isComponent: true,
  },
  contribution: {
    name: 'Contribution',
    headerBackgroundColor: MATERIAL_HEADER_BG,
  },
  gst: {
    name: 'GST%',
    headerBackgroundColor: MATERIAL_HEADER_BG,
  },
  cgst: {
    name: 'CGST%',
    alignment: 'flex-end',
    headerBackgroundColor: MATERIAL_HEADER_BG,
  },
  sgst: {
    name: 'SGST%',
    alignment: 'flex-end',
    headerBackgroundColor: MATERIAL_HEADER_BG,
  },
  igst: {
    name: 'IGST%',
    alignment: 'flex-end',
    headerBackgroundColor: MATERIAL_HEADER_BG,
  },
  gstValue: {
    name: 'GST Value',
    alignment: 'flex-end',
    headerBackgroundColor: MATERIAL_HEADER_BG,
  },
  cgstAmount: {
    name: 'CGST Value',
    alignment: 'flex-end',
    headerBackgroundColor: MATERIAL_HEADER_BG,
  },
  sgstAmount: {
    name: 'SGST Value',
    alignment: 'flex-end',
    headerBackgroundColor: MATERIAL_HEADER_BG,
  },
  igstAmount: {
    name: 'IGST Value',
    alignment: 'flex-end',
    headerBackgroundColor: MATERIAL_HEADER_BG,
  },

  totalAmountInclTax: {
    name: 'Total Amount (Incl. Tax)',
    alignment: 'flex-end',
    headerBackgroundColor: MATERIAL_HEADER_BG,
  },
  // Invoice-level GST totals (from invoice, not lines)
  totalgstPercentage: {
    name: 'Total GST%',
    alignment: 'flex-end',
    headerBackgroundColor: INVOICE_HEADER_BG,
  },
  totalcgstPercentage: {
    name: 'Total CGST%',
    alignment: 'flex-end',
    headerBackgroundColor: INVOICE_HEADER_BG,
  },
  totalsgstPercentage: {
    name: 'Total SGST%',
    alignment: 'flex-end',
    headerBackgroundColor: INVOICE_HEADER_BG,
  },
  totaligstPercentage: {
    name: 'Total IGST%',
    alignment: 'flex-end',
    headerBackgroundColor: INVOICE_HEADER_BG,
  },
  totalcgst: {
    name: 'Total CGST',
    alignment: 'flex-end',
    headerBackgroundColor: INVOICE_HEADER_BG,
  },
  totalsgst: {
    name: 'Total SGST',
    alignment: 'flex-end',
    headerBackgroundColor: INVOICE_HEADER_BG,
  },
  totaligst: {
    name: 'Total IGST',
    alignment: 'flex-end',
    headerBackgroundColor: INVOICE_HEADER_BG,
  },

  totalgstAmount: {
    name: 'Total GST Amount',
    alignment: 'flex-end',
    headerBackgroundColor: INVOICE_HEADER_BG,
  },
};
